<ng-container rtBlock="sc-catalog-item-page">
    <sc-page-header>
        <h1 slot="title" rtElem="title">{{ slug() }}</h1>
        <p slot="lead" rtElem="lead" i18n="@@catalogItemLead">
            Подробная страница материала в разработке. Вы можете сразу использовать его в конструкторе.
        </p>
    </sc-page-header>

    <section rtElem="frame">
        <button rtElem="cta" rtButton type="button" i18n="@@catalogItemUseCta" (click)="useInConstructor()">
            Использовать в конструкторе
        </button>
    </section>
</ng-container>
